var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4168_755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0191 27.8991C31.5383 27.8991 31.2178 27.5786 31.2178 27.0978V16.6812C31.2178 16.2004 31.5383 15.8799 32.0191 15.8799C32.4998 15.8799 32.8203 16.2004 32.8203 16.6812V27.0978C32.8203 27.5786 32.4998 27.8991 32.0191 27.8991Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 23.8928C19.8397 23.8928 19.7596 23.8928 19.5993 23.8127L7.58008 17.4024C7.3397 17.2422 7.17944 17.0018 7.17944 16.6813C7.17944 16.3608 7.3397 16.1204 7.58008 15.9601L19.5993 9.54988C19.8397 9.38962 20.0801 9.38962 20.3205 9.54988L32.3397 15.9601C32.5801 16.1204 32.7403 16.3608 32.7403 16.6813C32.7403 17.0018 32.5801 17.2422 32.3397 17.4024L20.3205 23.8127C20.2403 23.8928 20.1602 23.8928 20 23.8928Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1217 25.1741C20.8012 25.4145 20.4005 25.4946 19.9999 25.4946C19.5992 25.4946 19.1986 25.4145 18.8781 25.1741L11.9871 21.5684V24.6934C11.9871 27.1773 15.9133 29.5011 19.9999 29.5011C24.0864 29.5011 28.0127 27.1773 28.0127 24.6934V21.5684L21.1217 25.1741Z",
    fill: "#2D38AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4168_755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.641,
    height: 25.641,
    fill: "white",
    transform: "translate(7.17944 7.06543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR2);
export default __webpack_public_path__ + "static/media/r2.4e3ecb139a95bd20bb7a90e3b64dd385.svg";
export { ForwardRef as ReactComponent };